module.exports = __webpack_public_path__ + "media/images/pic/future_sight-643a750a18eff37dd171532fd8a90130.svg";